export class HttpError extends Error {
  readonly response: Response
  readonly status: number
  readonly data: unknown

  constructor(response: Response, data: unknown) {
    super(`HTTP ${response.status}: ${response.statusText}`)
    this.name = 'HttpError'
    this.response = response
    this.status = response.status
    this.data = data
  }
}

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError
}
